<template>
    <Dialog v-model:visible="visible" :style="{ width: '300px' }" :header="dialogHeader" :modal="true" class="p-fluid dialog-header" @hide="$emit('hide-dialog', true)">
        <div class="field">
            <label for="name">Theme Name:</label>
            <InputText id="name" type="text" v-model="theme.name" autofocus />
            <small class="p-invalid" v-if="submitted && !theme.name">Theme Name is required</small>
        </div>
        <div class="field">
            <custom-tree-select v-model="theme.parent_id" label="Parent Theme" :optionsTree="themeTree" />
            <Button v-if="theme.parent_id" label="Remove Parent" icon="pi pi-trash" class="p-button-warning" @click="removeParent" />
        </div>
        <div v-if="!themeHasDepartment" class="field">
            <custom-tree-select v-model="theme.department_id" :label="'Department'" :optionsTree="departmentTree" />
            <Button v-if="theme.department_id" label="Remove Department" icon="pi pi-trash" class="p-button-warning" @click="removeDepartment" />
        </div>
        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-danger" @click="visible = false" />
            <Button label="Submit" icon="pi pi-check" class="p-button-success" @click="submit()" />
        </template>
    </Dialog>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { ref, computed, defineEmits, onUnmounted, watch } from 'vue';
import { object, string } from 'yup';
import { departmentStore, themeStore } from '../../../../../store/global-stores';
import { showToast } from '../../../../../utilities/toast-handler';
import CustomTreeSelect from '../../../../../modules/custom-inputs/CustomTreeSelect.vue';

// emit
const emit = defineEmits(['hide-dialog']);

const visible = ref(true);
const submitted = ref(false);

const { theme, themes, themeTree, editId } = storeToRefs(themeStore);
const { departmentTree } = storeToRefs(departmentStore);

onUnmounted(() => {
    themeStore.initTheme();
});

// computed properties starts
const dialogHeader = computed(() => {
    return editMode.value ? 'Update Existing Theme' : 'Add New Theme';
});

const editMode = computed(() => {
    return editId.value;
});

const themeParentId = computed(() => {
    return theme.value.parent_id;
});

watch(themeParentId, () => {
    if (themeParentId.value && themeHasDepartment.value) {
        theme.value.department_id = null;
    }
});

const themeHasDepartment = computed(() => {
    // check if existing themes parent_id matches and has department id linked or no
    const departmentIdExists = themes.value.find((item) => item.id === theme.value.parent_id && item.department_id !== null);
    return departmentIdExists ? true : false;
});

const removeDepartment = () => {
    theme.value.department_id = null;
};

const removeParent = () => {
    theme.value.parent_id = null;
};

const validationSchema = object({
    name: string().required('Theme Name is required'),
});

const submit = async () => {
    try {
        submitted.value = true;
        await validationSchema.validate(theme.value, { abortEarly: false });
        const response = editMode.value ? await themeStore.updateTheme() : await themeStore.createTheme();
        if (response) {
            emit('hide-dialog');
        }
    } catch (error) {
        if (error.inner && typeof error.inner === 'object') {
            showToast({}, 'Input data invalid');
        }
    }
};
</script>
